import classNames from 'classnames';
import React from 'react';

type DiagonalLineLeftSeparatorPropTypes = {
  bottomClassName?: string;
  topClassName?: string;
  lineClassName?: string;
  className?: string;
};

const DiagonalLineLeftSeparator = ({
  bottomClassName = 'text-white',
  topClassName = 'text-gray-100',
  lineClassName = 'text-primary-main',
  className,
}: DiagonalLineLeftSeparatorPropTypes) => {
  return (
    <>
      <svg
        strokeMiterlimit={10}
        strokeWidth="2px"
        fill="none"
        stroke="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 187"
        className={classNames('hidden 640:block', className)}
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <polygon
              className={bottomClassName}
              fill="currentColor"
              stroke="currentColor"
              points="1440.06 142 1440.06 186 0.06 186 0.06 49 1440.06 142"
            />
            <polygon
              className={topClassName}
              fill="currentColor"
              stroke="currentColor"
              points="1440.06 0 1440.06 142 0.06 49 0.06 0 1440.06 0"
            />
            <line
              className={lineClassName}
              fill="currentColor"
              stroke="currentColor"
              x1="0.06"
              y1="48"
              x2="1440.06"
              y2="141"
            />
          </g>
        </g>
      </svg>

      <svg
        strokeMiterlimit={10}
        strokeWidth="3px"
        fill="none"
        stroke="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 700.26 186"
        className={classNames('640:hidden', className)}
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <polygon
              className={bottomClassName}
              fill="currentColor"
              stroke="currentColor"
              points="700.13 142 700.13 186 0.13 186 0.13 49 700.13 142"
            />
            <polygon
              className={topClassName}
              fill="currentColor"
              stroke="currentColor"
              points="700.13 0 700.13 142 0.13 49 0.13 0 700.13 0"
            />
            <line
              className={lineClassName}
              fill="currentColor"
              stroke="currentColor"
              x1="0.13"
              y1="48"
              x2="700.13"
              y2="141"
            />
          </g>
        </g>
      </svg>
    </>
  );
};

export default DiagonalLineLeftSeparator;
